import { render, staticRenderFns } from "./RoleIndexView.vue?vue&type=template&id=f879dbbc&scoped=true"
import script from "./RoleIndexView.vue?vue&type=script&lang=js"
export * from "./RoleIndexView.vue?vue&type=script&lang=js"
import style0 from "./RoleIndexView.vue?vue&type=style&index=0&id=f879dbbc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f879dbbc",
  null
  
)

export default component.exports